import { actionTypes } from "./actions";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.VIN_DECODER_GET_SUCCESS:
            return action.payload;

        case actionTypes.VIN_DECODER_GET_FAILURE:
            return {};

        default:
            return state;
    }
};